"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOINGUD_GALLERY_ADDRESS = exports.DOINGUD_DIAMOND_RNG_ADDRESS = exports.DOINGUD_DIAMOND_NFT_ADDRESS = exports.DOINGUD_DIAMOND_PACK_ADDRESS = exports.DOINGUD_DIAMOND_DUTCH_AUCTION_ADDRESS = exports.DOINGUD_DIAMOND_RANKED_OPEN_EDITION_ADDRESS = exports.DOINGUD_DIAMOND_EXCHANGE_ADDRESS = exports.DOINGUD_DIAMOND_RESALE_ADDRESS = exports.DOINGUD_DIAMOND_ENGLISH_AUCTION_ADDRESS = exports.DOINGUD_DIAMOND_LAZY_MINT_ADDRESS = exports.DOINGUD_DIAMOND_OPEN_EDITION_ADDRESS = exports.DOINGUD_DIAMOND_SALES_COMMON_ADDRESS = exports.DOINGUD_DIAMOND_TOKEN_ADDRESS = exports.DOINGUD_DIAMOND_SIO_ADDRESS = exports.DOINGUD_DIAMOND_OWNERSHIP_ADDRESS = exports.DOINGUD_DIAMOND_LOUPE_ADDRESS = exports.DOINGUD_DIAMOND_CUT_ADDRESS = exports.DOINGUD_LIBTOKEN_ADDRESS = exports.DOINGUD_DIAMOND_ADDRESS = exports.DOINGUD_DEPLOYER_ADDRESS = exports.USDC_ADDRESS = exports.LINK_ADDRESS = exports.ZERO_ADDRESS = exports.CHAIN_ID = void 0;
var CHAIN_ID;
(function (CHAIN_ID) {
    CHAIN_ID[CHAIN_ID["MAINNET"] = 1] = "MAINNET";
    CHAIN_ID[CHAIN_ID["ROPSTEN"] = 3] = "ROPSTEN";
    CHAIN_ID[CHAIN_ID["RINKEBY"] = 4] = "RINKEBY";
    CHAIN_ID[CHAIN_ID["GOERLI"] = 5] = "GOERLI";
    CHAIN_ID[CHAIN_ID["KOVAN"] = 42] = "KOVAN";
    CHAIN_ID[CHAIN_ID["POLYGON"] = 137] = "POLYGON";
    CHAIN_ID[CHAIN_ID["TESTNET"] = 31337] = "TESTNET";
    CHAIN_ID[CHAIN_ID["POLYGON_TESTNET"] = 80001] = "POLYGON_TESTNET";
})(CHAIN_ID = exports.CHAIN_ID || (exports.CHAIN_ID = {}));
exports.ZERO_ADDRESS = '0x0000000000000000000000000000000000000000';
exports.LINK_ADDRESS = {
    [CHAIN_ID.MAINNET]: '0x514910771AF9Ca656af840dff83E8264EcF986CA',
    [CHAIN_ID.KOVAN]: '0xa36085F69e2889c224210F603D836748e7dC0088',
    [CHAIN_ID.RINKEBY]: '0x01BE23585060835E02B77ef475b0Cc51aA1e0709',
    [CHAIN_ID.POLYGON]: '0xb0897686c545045aFc77CF20eC7A532E3120E0F1',
    [CHAIN_ID.POLYGON_TESTNET]: '0x326C977E6efc84E512bB9C30f76E30c160eD06FB',
};
exports.USDC_ADDRESS = {
    [CHAIN_ID.MAINNET]: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
    [CHAIN_ID.POLYGON]: '0x2791bca1f2de4661ed88a30c99a7a9449aa84174',
    [CHAIN_ID.POLYGON_TESTNET]: '0x64f6ab06374bfa6fc0a2070642ddb96d3564b864',
    // Hardhat testnet
    [CHAIN_ID.TESTNET]: '0xCD8a1C3ba11CF5ECfa6267617243239504a98d90',
    // Mainnet fork
    // [CHAIN_ID.TESTNET]: '0x2791bca1f2de4661ed88a30c99a7a9449aa84174',
};
exports.DOINGUD_DEPLOYER_ADDRESS = {
    [CHAIN_ID.POLYGON]: '0x10101098c00dd94898f40c81ba36e2334b5fae1a',
    [CHAIN_ID.POLYGON_TESTNET]: '0x548c1f56F11fbB8FDC2D1a59Cdaa13Ae82186777',
    // Mainnet fork
    // [CHAIN_ID.TESTNET]: '0x10101098c00dd94898f40c81ba36e2334b5fae1a',
};
exports.DOINGUD_DIAMOND_ADDRESS = {
    [CHAIN_ID.POLYGON]: '0xe3a161edd679fc5ce2db2316a4b6f7ab33a8ed6a',
    [CHAIN_ID.POLYGON_TESTNET]: '0x4137cF37598EE871d1F4A6DEE9188217Ed40c649',
    // Hardhat testnet
    [CHAIN_ID.TESTNET]: '0xDC11f7E700A4c898AE5CAddB1082cFfa76512aDD',
    // Mainnet fork
    // [CHAIN_ID.TESTNET]: '0xe3a161edd679fc5ce2db2316a4b6f7ab33a8ed6a',
};
exports.DOINGUD_LIBTOKEN_ADDRESS = {
    [CHAIN_ID.POLYGON_TESTNET]: '0xCb678bae632E5520fFAf43eA54439e661B770eBe',
    [CHAIN_ID.POLYGON]: '0x0bf53a688e16ca099a41a11bc0a56644c4770372',
};
exports.DOINGUD_DIAMOND_CUT_ADDRESS = {
    [CHAIN_ID.POLYGON_TESTNET]: '0x943c6882D18D5CA52b2711fb9009963068E9B59d',
    [CHAIN_ID.POLYGON]: '0x477d8f43a4548bfaf6b667e0e703546de8c674cd',
};
exports.DOINGUD_DIAMOND_LOUPE_ADDRESS = {
    [CHAIN_ID.POLYGON_TESTNET]: '0x92f58945CDCFf883f74DB938C000978DF87F76cB',
    [CHAIN_ID.POLYGON]: '0xfb42b9f16b655620897fbf2584ffc178d9a3241c',
};
exports.DOINGUD_DIAMOND_OWNERSHIP_ADDRESS = {
    [CHAIN_ID.POLYGON_TESTNET]: '0xFa0087575A3E56E1bab594d9bC1B4C2D22FB748D',
    [CHAIN_ID.POLYGON]: '0xb0287c12971704a364adaff25f0d2c71334c1b72',
};
exports.DOINGUD_DIAMOND_SIO_ADDRESS = {
    [CHAIN_ID.POLYGON_TESTNET]: '0xdb1811662F64E429B25B4E133106466d54C4ED2e',
    [CHAIN_ID.POLYGON]: '0xf5985d889fdc6afc7a31290b8ce027054a795480',
};
exports.DOINGUD_DIAMOND_TOKEN_ADDRESS = {
    [CHAIN_ID.POLYGON_TESTNET]: '0x41079b870Dbc5329161DdDBC854cBe8D23Af57b0',
    [CHAIN_ID.POLYGON]: '0x48d740d3d6c5b9bfe478d2ed276ef4a5064c4b2b',
};
exports.DOINGUD_DIAMOND_SALES_COMMON_ADDRESS = {
    [CHAIN_ID.POLYGON_TESTNET]: '0xe52f43865feeD6568C5F4907b508e2Ec9F63b33D',
    [CHAIN_ID.POLYGON]: '0x5bdef3d12c2810625fa388938025f3949fd57551',
};
exports.DOINGUD_DIAMOND_OPEN_EDITION_ADDRESS = {
    [CHAIN_ID.POLYGON_TESTNET]: '0x4dbC4f922A35A4c0515D5e4c9b13952CeB062507',
};
exports.DOINGUD_DIAMOND_LAZY_MINT_ADDRESS = {
    [CHAIN_ID.POLYGON_TESTNET]: '0x46c90Af35215da63Ae0FA1a9452788EE43e3e9c2',
    [CHAIN_ID.POLYGON]: '0xbd83fd6101d0ec17ae52408cdecc17e91b45c12d',
};
exports.DOINGUD_DIAMOND_ENGLISH_AUCTION_ADDRESS = {
    [CHAIN_ID.POLYGON_TESTNET]: '0xF93050a7eaCEE0d9eB15dEEDF255E33Da022C05c',
    [CHAIN_ID.POLYGON]: '0x0f9166141ed2596b5adb28a783ef856ae4067968',
};
exports.DOINGUD_DIAMOND_RESALE_ADDRESS = {
    [CHAIN_ID.POLYGON_TESTNET]: '0xCFeaac90E7F80DBe5B50e5883832e2108b7d4370',
    [CHAIN_ID.POLYGON]: '0x0e0fd7bc249dbd91c739ad41376b09e5a597575a',
};
exports.DOINGUD_DIAMOND_EXCHANGE_ADDRESS = {
    [CHAIN_ID.POLYGON_TESTNET]: '0x0DAab4F3ca0FFEF6490582e94dAE636359E1764E',
    [CHAIN_ID.POLYGON]: '0xd9a62c8ee0c5ea2b36375b0bdb0dd7994fb38718',
};
exports.DOINGUD_DIAMOND_RANKED_OPEN_EDITION_ADDRESS = {
    [CHAIN_ID.POLYGON_TESTNET]: '0x5E55E13348fEe19530E5F9c792C3995c5BEdB3EB',
    [CHAIN_ID.POLYGON]: '0xe19218d57a961b81907b2cc2c74a54c99764ae65',
};
exports.DOINGUD_DIAMOND_DUTCH_AUCTION_ADDRESS = {
    [CHAIN_ID.POLYGON_TESTNET]: '0x80d031326A8D0710082FD9E019D3c76678c1a7d7',
};
exports.DOINGUD_DIAMOND_PACK_ADDRESS = {
    [CHAIN_ID.POLYGON_TESTNET]: '0x9F445EB85caE11397043c940c7dEc74171440Af8',
};
exports.DOINGUD_DIAMOND_NFT_ADDRESS = {
    [CHAIN_ID.POLYGON_TESTNET]: '0x326553897037A847317FFEe083776206bD90b512',
    [CHAIN_ID.POLYGON]: '0xf747518144b62691e02bfb37260fea5baf6a26de',
};
exports.DOINGUD_DIAMOND_RNG_ADDRESS = {
    [CHAIN_ID.POLYGON_TESTNET]: '0x58171fb04a44e937bBB93113a87092D458c6d92e',
};
exports.DOINGUD_GALLERY_ADDRESS = {
    [CHAIN_ID.POLYGON_TESTNET]: '0x544A57B2fcC76e5E733C019632Ef391e5B3951A8',
    [CHAIN_ID.POLYGON]: '0x3267b5d0143478e6073f91e3409dcdcf9b0d8208',
};
